export default "__VITE_ASSET__Ch5UMz77__"